// packages/eden-table/src/components/RowSelection/Context.jsx
import { createContext } from "react";
var RowSelectionContext = createContext();
var Context_default = RowSelectionContext;
export {
  Context_default as default
};
